import Axios from 'axios'
import {
    router
} from '../router'
import store from '../store/index'
import app from '../main'
import {
    Notify,
    Toast,
    Dialog
} from 'vant';
// if (window.localStorage.getItem('token')) {
//     Axios.defaults.headers.common['Authorization'] = `Bearer ` + window.localStorage.getItem('token')
// }
// http://service.aggregator.taohualian168.net
// apiUrl = 'https://api' + HOST + '.com';
// Axios.defaults.baseURL = apiUrl;
export let instance = Axios.create({
    //  baseURL: process.env.NODE_ENV === 'production' ? 'https://service.aggregator.taohualian168.net' : 'http://localhost:1000'
    // baseURL:'https://service.aggregator.taohualian168.net'
    baseURL: webconfig.path,
    // baseURL: 'http://192.168.0.105:22397'
})

instance.interceptors.request.use(
    config => {
        app.$Progress.start()
        let userInfo = store.getters.userInfo;
        if (userInfo && userInfo.token && userInfo.isLogin) {
            config.headers["Authorization"] = "Bearer " + userInfo.token;
        }
        config.headers.shopId = 2;
        return config;
    },
    err => {
        return Promise.reject(err)
    }
);
// respone拦截器
instance.interceptors.response.use(
    response => {
        app.$Progress.finish()
        console.log(response.data.errors, 'http')
        if (response.data.errors === "16060") {
            router.replace({
                path: '/page',
            })
            return Promise.reject(response.data.errors)
        }
        if (response.data.errors === "17070！") {
            router.replace({
                path: '/employeeCode',
            })
            return Promise.reject(response.data.errors)
        }
        if (response.data.errors === "18080！") {
            Dialog.alert({
                message: "积分中心维护中...",
                messageAlign: "center",
                confirmButtonText: "确认",
              }).then(() => {
                // on close
              });
            return Promise.reject(response.data.errors)
        }
        if (response.data.statusCode === 401) {
            Notify({
                type: 'primary',
                message: '登录过期，请重新登录'
            });
            // token失效 清除状态
            store.dispatch('buyAgentStatus', { show: false });
            if (router.currentRoute.path !== '/login') {
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
            return Promise.reject(response.data.errors)
        }
        if (response.data.statusCode === 403) {
            Notify({
                type: 'primary',
                message: '登录过期，请重新登录'
            });
            // token失效 清除状态
            store.dispatch('buyAgentStatus', { show: false });
            if (router.currentRoute.path !== '/login') {
                router.replace({
                    path: '/login',
                    query: {
                        redirect: router.currentRoute.fullPath
                    } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                })
            }
            return Promise.reject(response.data.errors)
        }
        if (response.data.statusCode === 500) {
            // Notify({
            //     type: 'danger',
            //     message: response.data.errors
            // });
              // 如果返回‘购买数量不足无法申请店员’。会员中心页面不显示申请店员按钮，不提示错误。其他正常走
              if(response.data.errors=='购买数量不足无法申请店员。'||response.data.errors=='优惠码不足，请手动领取优惠码'){
            }else{
                Toast(response.data.errors)
            }
            // Toast(response.data.errors)

            return Promise.reject(response.data.errors)
        }
        if (response.data.statusCode === 400) {
            // console.log('responseErr', response.data.errors,Object.values(response.data.errors)[0][0], 400)
            // let errorsMessage = Object.values(response.data.errors)[0][0];
            // Notify({
            //     type: 'danger',
            //     message: response.data.errors
            // });
            let errors =  JSON.stringify(response.data.errors)
            Toast(errors);
            // Toast(errorsMessage);
            // return Promise.reject(response.data.errors)
        }
        return response.data
    },
    error => {
        if (error == "Error: Network Error") {
            router.replace('cannotAccess')
        } else {
            if (error.response) {
                console.log(error.response, 'httpErr')
                switch (error.response.status) {
                    case 401:
                        Notify({
                            type: 'primary',
                            message: '登录过期，请重新登录'
                        });
                        // token失效 清除状态
                        store.dispatch('buyAgentStatus', { show: false });
                        if (router.currentRoute.path !== '/login') {
                            router.replace({
                                path: '/login',
                                query: {
                                    redirect: router.currentRoute.fullPath
                                } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            })
                        }
                        break;
                    case 404:
                        router.replace('Missing')
                        break;
                    case 403:
                        Notify({
                            type: 'primary',
                            message: '登录过期，请重新登录'
                        });
                        // token失效 清除状态
                        store.dispatch('buyAgentStatus', { show: false });
                        if (router.currentRoute.path !== '/login') {
                            router.replace({
                                path: '/login',
                                query: {
                                    redirect: router.currentRoute.fullPath
                                } // 将跳转的路由path作为参数，登录成功后跳转到该路由
                            })
                        }
                        // shareCode
                        // if (error.response.data.Type == "common") {
                        //     Notify({
                        //         type: "danger",
                        //         message: "你当前的状态不能访问-common"
                        //     });
                        //     router.replace({
                        //         path: '/setting',
                        //         query: {
                        //             redirect: router.currentRoute.fullPath
                        //         }
                        //     })
                        // } else if (error.response.data.Type == "employee") {
                        //     Notify({
                        //         type: "danger",
                        //         message: "你当前的状态不能访问-employee"
                        //     });
                        // }
                        // app.$Progress.finish();
                        break;
                    case 400:
                        console.log('err', 400)
                        if (error.response.data.errors != undefined) {
                            Notify({
                                type: "danger",
                                message: error.response.data.errors.DomainValidations || error.response.data.errors.Name
                            });
                        } else {
                            Notify({
                                type: "danger",
                                message: error.response.data
                            });
                        }
                        app.$Progress.finish();
                        break;
                    case 500:
                        router.replace('Missing')
                        break;
                }
            } else {
                return Promise.reject(error)
            }
        }
        return Promise.reject(error.response)
    }
)